module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"new_lost_backlinks":"New and Lost Backlinks","number_of_backlinks":"Number of backlinks","new":"New backlinks","lost":"Lost backlinks"},"fr":{"new_lost_backlinks":"Suivi des Backlinks","number_of_backlinks":"Nombre de backlinks","new":"Nouveaux","lost":"Perdus"},"de":{"new_lost_backlinks":"Suivi des Backlinks","number_of_backlinks":"Backlink-Name","new":"Neu","lost":"Verloren"}}')
  delete Component.options._Ctor
}
